<template>
  <div
    class="services-test-area si-without-border-radius bg-mg ptb-100 position-relative overflow-hidden"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <div class="container mw-1356">
      <div
        class="services-test-content"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">تجربة الخدمة</span>
        <h2 class="text-white">
          ابدأ الآن! لا تتردد في طلب تجربة السيرفر قبل الاشتراك الرسمي
        </h2>
        <p class="text-silver">
          احصل على حساب تجريبي للتحقق من ثبات البث، والوصول الكامل لجميع القنوات ومكتبة الأفلام والمسلسلات.
        </p>
        <div class="d-flex align-items-center amount">
          <div class="flex-shrink-0">
            <i class="flaticon-tv"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h2>$ 1.99<sub>/ للتجربة</sub></h2>
            <span>تجربة مضمونة لضمان الرضا الكامل قبل الالتزام بباقة طويلة.</span>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <a href="https://wa.me/447429916178" target="_blank" class="btn bg-grey-teal">
            <span class="border-style">اطلب تجربة السيرفر الآن</span>
          </a>
          <a href="https://wa.me/447429916178" target="_blank" class="btn bg-transparent">
            <span class="border-style">
              <span>تواصل معنا عبر الواتساب</span> لأي استفسار
            </span>
          </a>
        </div>
      </div>
    </div>

    <img src="@/assets/images/shape-9.png" class="shape shape-9" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestOurService",
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/services-test-bg-2.jpg");

    return {
      bgImage,
    };
  },
});
</script>